import React from "react";
import PropTypes from "prop-types";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";

const ToggleSwitch = (props) => {
	const knobBase = (
		<div className={`ToggleSwitch_knob ${props.checked ? "ToggleSwitch_knobActive" : ""}`}>
			<div className="ToggleSwitch_knobBase" />
		</div>
	);

	const children = (
		<div className={`ToggleSwitch_bar ${props.checked ? "ToggleSwitch_barActive" : ""}`} onClick={props.onToggle}>
			{knobBase}
		</div>
	);

	return (
		<div className={`ToggleSwitch_container ${props.bodyClass}`}>
			{props.toolTipOverlayText ? (
				<Tooltip
					placement="bottom"
					trigger={["hover"]}
					destroyTooltipOnHide={true}
					overlayClassName="Tooltip"
					overlay={<span>{props.toolTipOverlayText}</span>}
				>
					{children}
				</Tooltip>
			) : (
				children
			)}
		</div>
	);
};

ToggleSwitch.propTypes = {
	onToggle: PropTypes.func.isRequired,
	checked: PropTypes.bool.isRequired,
	toolTipOverlayText: PropTypes.element,
	bodyClass: PropTypes.string,
};

export default ToggleSwitch;
